import * as React from 'react';
import { IAppPropsWithRoute } from '../../common/types';
import { withRouter } from 'react-router-dom';
import AddEditLocation from './AddEditLocationWidget';
import { useDispatch, useSelector} from 'react-redux';
import { showNavbar } from '../../store/modules/appStateSlice';
import { RootState } from '../../store/rootReducer';

interface AddEditUserPageProps extends IAppPropsWithRoute {

};

function AddEditLocationPage(props: AddEditUserPageProps): JSX.Element {
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(showNavbar(true));
    }, [])
    const locationId = props.match.params.locationId;

    const { authStore } = useSelector((state: RootState) => state);

    const renderChild = () => {
        return <AddEditLocation id={locationId} authStore={authStore}/>;
    }

    return (
        <React.Fragment>
            {renderChild()}
        </React.Fragment>
    );
}

export default React.memo(withRouter(AddEditLocationPage));